import type { CpuStats, PlayerPublic } from '@xox/shared'
import { useFetch } from '../hooks/useFetch'
import { plural } from '../lib/format'
import { Card } from './ui'

interface Props {
  bot: PlayerPublic
  playerId: string | null
  /** Room only: people watching this game. */
  spectators?: number
  /** Stable, module-level loader for this game's bot records (used when `stats` is not passed). */
  load: () => Promise<CpuStats>
  /** Pass stats already loaded (the wall) to skip the fetch. */
  stats?: CpuStats | null
}

const noStats = (): Promise<CpuStats | null> => Promise.resolve(null)

/** Your running score against a house bot (from the same stats the wall shows). */
export function CpuRecordCard({ bot, playerId, spectators = 0, load, stats }: Props) {
  const fetched = useFetch<CpuStats | null>(stats === undefined ? load : noStats)
  const data = stats ?? fetched.data
  const mine = data?.players.find((p) => p.playerId === playerId)
  return (
    <Card className="flex flex-col gap-1.5 border-l-4 border-l-violet-500">
      <h2 className="font-semibold">Your record vs {bot.nickname}</h2>
      <p className="text-2xl font-black tabular-nums">
        {mine?.wins ?? 0} – {mine?.losses ?? 0} – {mine?.draws ?? 0}
        <span className="ml-2 text-xs font-medium text-slate-500">wins – losses – draws</span>
      </p>
      <p className="text-xs text-slate-500">
        {data
          ? `${data.totals.games} attempts by everyone, ${data.totals.draws} draws, ${data.totals.wins === 0 ? 'no wins' : plural(data.totals.wins, 'win')}.`
          : ''}
        {spectators > 0 ? ` ${spectators} watching.` : ''}
      </p>
    </Card>
  )
}
